export const appTitle = "Humanitarian Lives Saved Approach";
export const appTitleAbbr = "H-LiST";

/* Forms */
export const homePageForm = "HLHomePageForm";
export const welcomeForm = "HLWelcomeForm";
export const introForm = "HLIntroForm";
export const stepByStepForm = "HLStepByStepForm";
export const step1Form = "HLStep1Form";
export const step2Form = "HLStep2Form";
export const step3Form = "HLStep3Form";
export const step4Form = "HLStep4Form";
export const step5Form = "HLStep5Form";
export const step6Form = "HLStep6Form";
export const step7Form = "HLStep7Form";
export const FAQsHelpForm = "HLFAQsHelpForm";

export const resources = "Resources";
export const about = "About";

//old
export const portalForm = "HLPortalForm";

export const nextBtnText = "Next";
export const backBtnText = "Back";

export const noCountrySelected = -1;

// export const ANC_DeliveryArea = 1;
// export const EPI_Area         = 2;
// export const nutritionArea    = 3;
// export const OPD_CommOutreach = 4;
// export const WASH_Area        = 5;
// export const numIntervAreas   = WASH_Area;

// export const ANC_DeliveryAreaMstID = 1;
// export const EPI_AreaMstID         = 2;
// export const nutritionAreaMstID    = 3;
// export const OPD_CommOutreachMstID = 4;
// export const WASH_AreaMstID        = 5;

export const noScaleUpSelected = 0;
export const scaleUp40t60Perc = 1;
export const scaleUp60t80Perc = 2;
export const scaleUp80t90Perc = 3;
export const scaleUp90t95Perc = 4;
export const numScaleUpScenarios = scaleUp90t95Perc;

export const noScaleUpSelectedMstID = 0;
export const scaleUp40t60PercMstID = 1;
export const scaleUp60t80PercMstID = 2;
export const scaleUp80t90PercMstID = 3;
export const scaleUp90t95PercMstID = 4;

export const mortProfile1 = 1;
export const mortProfile2 = 2;
export const mortProfile3 = 3;
export const numMortProfiles = mortProfile3;

export const regEastAfrica = 1;
export const regWestAfrica = 2;
export const regSouthernAfrica = 3;
export const regCentralAfrica = 4;
export const numRegions = regCentralAfrica;

export const highHIV_Prev = 1;
export const medHIV_Prev = 2;
export const lowHIV_Prev = 3;
export const numHIV_PrevLevels = lowHIV_Prev;

export const acceptable_NutStatStunt = 1; // < 10%            --> 5%
export const poor_NutStatStunt = 2; // >= 10% to < 20 % --> 15%
export const serious_NutStatStunt = 3; // >= 20% to < 30 % --> 25 %
export const critical_NutStatStunt = 4; // >= 30%           --> 30%
export const unsureNA_NutStatStunt = 5; // N/A              --> use SpectrumWeb defaults

export const acceptable_NutStatStuntMstID = 1; // < 10%            --> 5%
export const poor_NutStatStuntMstID = 2; // >= 10% to < 20 % --> 15%
export const serious_NutStatStuntMstID = 3; // >= 20% to < 30 % --> 25 %
export const critical_NutStatStuntMstID = 4; // >= 30%           --> 30%
export const unsureNA_NutStatStuntMstID = 5; // N/A              --> use SpectrumWeb defaults

export const acceptable_NutStatWast = 1; // < 5%             --> 2.5%
export const poor_NutStatWast = 2; // >= 5% to < 10 %  --> 7.5%
export const serious_NutStatWast = 3; // >= 10% to < 15 % --> 12.5 %
export const critical_NutStatWast = 4; // >= 15%           --> 15%
export const unsureNA_NutStatWast = 5; // N/A              --> use SpectrumWeb defaults

export const acceptable_NutStatWastMstID = 1; // < 5%             --> 2.5%
export const poor_NutStatWastMstID = 2; // >= 5% to < 10 %  --> 7.5%
export const serious_NutStatWastMstID = 3; // >= 10% to < 15 % --> 12.5 %
export const critical_NutStatWastMstID = 4; // >= 15%           --> 15%
export const unsureNA_NutStatWastMstID = 5; // N/A              --> use SpectrumWeb defaults

export const age0t4Yrs = 1;
export const age5t14Yrs = 2;
export const age15t64Yrs = 3;
export const age64PlusYrs = 4;
export const numAgeGroups = age64PlusYrs;

export const age0t4YrsMstID = 1;
export const age5t14YrsMstID = 2;
export const age15t64YrsMstID = 3;
export const age64PlusYrsMstID = 4;

export const noInterv = -1;
export const allIntervTypes = 0;
export const maternalInterv = 1;
export const childrenInterv = 2;

/* "Micronutrient supplementation (iron and multiple micronutrients)" is a special intervention,
    because the interventions that make it up are from different groups. Since scale-up is done by
    group and can therefore be different for the constituent interventions, we do not show certain info
    for this intervention in the results table (group, base coverage, target coverage).
    Should really get this from the server, but this is faster. */
export const microSuppIntervMstID = 254;

export const ANCAndDeliveryAreaMstID = 1;
export const nutritionAreaMstID = 3;

/* Intervention objects */
export const intervObj = {
    name: "Names",
    mstID: "MstID",
    intervAreaMstID: "GroupMstID",
    diseaseAreaMstID: "DiseaseAreaMstID",
    isMaternal: "maternal",
    isChildren: "postneonatal",
};

/* Intervention area objects */
export const intervAreaObj = {
    name: "Names",
    mstID: "MstID",
    diseaseAreaObjList: "DiseaseAreaObjList",
    includeBool: "includeBool", // specific to client
    scaleUpCurrID: "scaleUpCurrID", // specific to client
};

export const diseaseAreaObjList = {
    name: "Names",
    mstID: "MstID",
};

export const rankedIntervObj = {
    mstID: "mstID",
    percent: "perc",
    name: "name",
};

/* CountryRegionObj */
export const countryRegionCode = "countryRegionCode";
export const countryRegionName = "countryRegionName";

/* Drawers */
export const resultsDrawer = "HLResultsDrawer";

/* URLS */
export const UNHCR_URL = "https://www.unhcr.org/en-us/";
export const LiST_URL = "https://www.livessavedtool.org/";
export const Gates_URL = "https://www.gatesfoundation.org/";
export const humanitHealthMailLink = "humanithealth@jhu.edu";
export const webinar_URL =
    "https://ctlcoursevideoarchive.s3.amazonaws.com/H%20List%20Webinar/H%20list%20Live%20Webinar.mp4";
export const videoOverview_URL =
    "https://ctlcoursevideoarchive.s3.us-east-1.amazonaws.com/H%20List%20Webinar/H%20LiST%20Promo.mp4";

/* Resources */
export const powerPointPresPDF = "H-LiST_Summary_Overview_Presentation_February_2020.pdf";
export const techNotePDF = "H-LiST_Technical_Note_v.1_2020_02_20.pdf";
export const templatesXLSX = "H-LiST_Templates_February_2020.xlsx";
export const guidanceDocPDF = "H-LiST_Guidance_Document_February_2020.pdf";
export const overviewPDF = "H-LiST_One_page_overview_February_2020.pdf";

/* Images */
export const step4ImgURL = "https://flic.kr/p/2hPi1YC";
export const step5ImgURL = "https://flic.kr/p/PgdTNw";
export const step6ImgURL = "https://flic.kr/p/eeRmSs";
export const step7ImgURL = "https://flic.kr/p/2hPh2Vo";

export const introAreaText = "Introduction";
export const stepByStepAreaText = "Step-by-step H-LiST approach";
export const step1AreaText1 = "Step 1:";
export const step1AreaText2 = "Coverage";
export const step2AreaText1 = "Step 2:";
export const step2AreaText2 = "Prioritized interventions";
export const step3AreaText1 = "Step 3:";
export const step3AreaText2 = "Incremental activities";
export const step4AreaText1 = "Step 4:";
export const step4AreaText2 = "Incremental costs";
export const step5AreaText1 = "Step 5:";
export const step5AreaText2 = "Feasibility assessment";
export const step6AreaText1 = "Step 6:";
export const step6AreaText2 = "Final decision";
export const step7AreaText1 = "Step 7:";
export const step7AreaText2 = "Monitor and adjust";
export const FAQsHelpAreaText = "FAQs and help";
